import {useEffect, useState} from "react";
import {getItemsCheckoutPrice} from "../api/apiClient";

// The price preview and the payment must send the same items, so both build them here.
export const toCheckoutItems = (cartLines) =>
    cartLines.map((line) => ({itemVariantId : line.itemVariantId, quantity : line.quantity}));

export const useItemsCheckoutPrice = (cartLines, coupon, paymentMethod, reloadTrigger) => {
    const [checkoutPrice, setCheckoutPrice] = useState(null);
    const [isPricing, setIsPricing] = useState(false);
    const [pricingFailed, setPricingFailed] = useState(false);

    useEffect(() => {
        // An empty cart has nothing to price; the checkout page sends the customer back to the cart.
        if (cartLines.length === 0) {
            return;
        }

        const abortController = new AbortController();
        const items = toCheckoutItems(cartLines);

        // Drop the previous price so a removed coupon or the old payment method's discount is
        // neither shown nor paid with while the new price is on its way.
        setCheckoutPrice(null);
        setIsPricing(true);
        setPricingFailed(false);

        getItemsCheckoutPrice(items, coupon, paymentMethod, abortController.signal)
            .then(setCheckoutPrice)
            .catch((exception) => {
                console.log(exception);
                // An aborted request has already been replaced by a newer one.
                if (!abortController.signal.aborted) {
                    setPricingFailed(true);
                }
            })
            .finally(() => {
                // An aborted request has already been replaced by a newer one that is still pricing.
                if (!abortController.signal.aborted) {
                    setIsPricing(false);
                }
            });

        return () => {
            abortController.abort();
        };
    }, [cartLines, coupon, paymentMethod, reloadTrigger]);

    return {checkoutPrice, isPricing, pricingFailed};
};
